import React from 'react'
import PropTypes from 'prop-types'
import withLayout from '../../../layout/withLayout'
import ContentBox from '../../../layout/component/ContentBox'
import { lifecycle } from 'recompose'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import Table from '../../../table/component/Table'
import taskListColumnList from './all-open-tasklist-column-list'
import { getStoreDropDown } from '../../../store/util/renderStoreName'
import { PROCESS_NAME_SELECT } from '../../util/names'
import { ROLE_LIST_EMPLOYEE_SELECT, ROLE_LIST_PARTNER_SELECT } from '../../../security/state/auth/const'
import TableColumnSelector from "../../../table/component/TableColumnSelector"
import { COUNTRY_CODE_LIST } from '../../../internationalization/const'

const AllOpenTaskList = ({ tableData, changeFilter, toggleSort, toggleMultiSort, gotoPage, navigateToTaskDetail, partnerList, toggleColumnVisibility }) => {
    const columnList = taskListColumnList(partnerList)

    return (
        <ContentBox title="All open task">
            <TableColumnSelector
                resultsNumber={tableData.objectList.length}
                hiddenColumns={tableData.hiddenColumns}
                columnList={columnList}
                toggleColumnVisibility={toggleColumnVisibility}
            />

            <Row>
                <Column size={12}>
                    <Table
                        {...tableData}
                        changeFilter={changeFilter}
                        toggleSort={toggleSort}
                        toggleMultiSort={toggleMultiSort}
                        gotoPage={gotoPage}
                        columnList={columnList}
                        idProperty="id"
                        onRowClick={(task) => {
                            navigateToTaskDetail(task.id)
                        }}
                        filterSetting={{
                            vip: {
                                type: 'select',
                                valueList: [
                                    {
                                        id: '0',
                                        value: 'no influencer',
                                    },
                                    {
                                        id: '1',
                                        value: 'influencer',
                                    },

                                ],
                            },
                            partnerId: {
                                type: 'select',
                                valueList: partnerList.map(partner => ({
                                    id: partner.id,
                                    value: partner.displayName,
                                })),
                            },
                            store: {
                                type: 'select',
                                valueList: getStoreDropDown(),
                            },
                            countryCode: {
                                type: 'select',
                                valueList: COUNTRY_CODE_LIST,
                            },
                            processName: {
                                type: 'select',
                                valueList: PROCESS_NAME_SELECT,
                            },
                            role: {
                                type: 'select',
                                valueList: [
                                    ...ROLE_LIST_EMPLOYEE_SELECT,
                                    ...ROLE_LIST_PARTNER_SELECT,
                                ],
                            },
                            status: {
                                type: 'input',
                                beforeQuery: (value) => {
                                    if (!value) {
                                        return value
                                    }
                                    return value.replace(/ /g, '_')
                                },
                                beforeRender: (value) => {
                                    if (!value) {
                                        return value
                                    }
                                    return value.replace(/_/g, ' ')
                                },
                            },
                            name: {
                                type: 'input',
                                beforeQuery: (value) => {
                                    if (!value) {
                                        return value
                                    }
                                    return value.replace(/ /g, '_')
                                },
                                beforeRender: (value) => {
                                    if (!value) {
                                        return value
                                    }
                                    return value.replace(/_/g, ' ')
                                },
                            },
                        }}
                    />
                </Column>
            </Row>
        </ContentBox>
    )
}


AllOpenTaskList.propTypes = {
    navigateToTaskDetail: PropTypes.func.isRequired,
}

export default lifecycle({
    componentDidMount () {
        this.props.initialTableQuery()
        this.props.initialColumnsVisibility()
    },
})(withLayout(AllOpenTaskList))



// WEBPACK FOOTER //
// ./src/modules/process/component/task-list/AllOpenTaskList.js